import * as yup from 'yup';
export { yup };
import dayjs from 'dayjs';
import { isValidations } from '../types/typeGuards.js';

yup.addMethod(yup.array, 'arrayCustomProp', function arrayCustomProp(properties, requiredProperties) {
    return this.test({
        test: arr => !!arr &&
            arr.length > 0 &&
            ((!requiredProperties && properties.some(property => arr[0][property] > 0)) ||
                (!!requiredProperties &&
                    properties.some(property => arr[0][property] > 0) &&
                    requiredProperties.every(property => arr[0][property] > 0)))
    });
});
yup.addMethod(yup.string, 'zipCode', function zipCode(...args) {
    return this.matches(/^[0-9]{5}$/, args[0]);
});
yup.addMethod(yup.string, 'phone', function phone(...args) {
    return this.matches(/^[+]*[\s/0-9]+$/, args[0]);
});
yup.addMethod(yup.string, 'countryCode', function countryCode(...args) {
    return this.matches(/^\+?\d{1,5}$/, args[0]);
});
// eslint-disable-next-line func-names
yup.addMethod(yup.object, 'isOlderThanAgeOnDate', function (...args) {
    return this.test({
        message: args[0],
        test: function isOlderThanAgeOnDate(value, context) {
            const dayProp = context.options.context?.isOlderThanAgeOnDateDayProp;
            const monthProp = context.options.context?.isOlderThanAgeOnDateMonthProp;
            const minAge = context.options.context?.isOlderThanAgeOnDateMinAge;
            const startDate = dayjs(context.options.context?.isOlderThanAgeOnDateStartDate);
            if (!dayProp || !monthProp || !startDate || !minAge || !value)
                return false;
            const birthDate = dayjs(`${value.code}-${this.parent[monthProp].code}-${this.parent[dayProp].code}`);
            const birthDateAdded = birthDate.add(minAge, 'year');
            const daysToAdd = 1;
            return birthDateAdded.isBefore(startDate.add(daysToAdd, 'day'), 'day');
        }
    });
});
// eslint-disable-next-line func-names
yup.addMethod(yup.string, 'isBirthDateYoungerThanMaxAgeOnDate', function (...args) {
    return this.test({
        message: args[1],
        test: function isLowerThanAgeOnDateString(value, context) {
            const startDate = dayjs(context.options.context?.startDate);
            if (!startDate || !value)
                return false;
            const birthDate = dayjs(value);
            const maxAge = args[0];
            return birthDate.add(maxAge, 'year').isSameOrAfter(startDate, 'day');
        }
    });
});
// eslint-disable-next-line func-names
yup.addMethod(yup.string, 'isBirthDateOlderThanMinAge', function (...args) {
    return this.test({
        message: args[1],
        test: function isOlderThanAgeOnDateString(value, context) {
            const startDate = dayjs(context.options.context?.startDate);
            if (!startDate || !value)
                return false;
            const birthDate = dayjs(value);
            const minAge = args[0];
            return birthDate.add(minAge, 'year').isSameOrBefore(startDate, 'day');
        }
    });
});
// eslint-disable-next-line func-names
yup.addMethod(yup.string, 'isBirthDateYoungerThanMaxAgeOnCurrentDate', function (...args) {
    return this.test({
        message: args[1],
        test: function isBirthDateYoungerThanMaxAgeOnCurrentDate(value) {
            const now = dayjs();
            if (!now || !value)
                return false;
            const birthDate = dayjs(value);
            const maxAge = args[0];
            return birthDate.add(maxAge, 'year').isSameOrAfter(now, 'day');
        }
    });
});
// eslint-disable-next-line func-names
yup.addMethod(yup.string, 'isBirthDateOlderThanMinAgeOnCurrentDate', function (...args) {
    return this.test({
        message: args[1],
        test: function isBirthDateOlderThanMinAgeOnCurrentDate(value) {
            const now = dayjs();
            if (!now || !value)
                return false;
            const birthDate = dayjs(value);
            const minAge = args[0];
            return birthDate.add(minAge, 'year').isSameOrBefore(now, 'day');
        }
    });
});
// eslint-disable-next-line func-names
yup.addMethod(yup.string, 'isAdultOnCurrentDate', function (...args) {
    return this.test({
        message: args[0],
        test: function isAdultOnCurrentDate(value, context) {
            const adultMinAge = context.options.context?.adultMinAge;
            const now = dayjs();
            if (!now || !adultMinAge || !value)
                return false;
            const birthDate = dayjs(value);
            return birthDate.add(adultMinAge, 'year').isSameOrBefore(now, 'day');
        }
    });
});
yup.addMethod(yup.string, 'isOlderThanAgeOnDateString', function (...args) {
    return this.test({
        message: args[0],
        test: function isOlderThanAgeOnDate(value, context) {
            const adultMinAge = context.options.context?.adultMinAge;
            const startDate = dayjs(context.options.context?.startDate);
            if (!startDate || !adultMinAge || !value)
                return false;
            const birthDate = dayjs(value);
            const birthDateAdded = birthDate.add(adultMinAge, 'year');
            const daysToAdd = 1;
            return birthDateAdded.isBefore(startDate.add(daysToAdd, 'day'), 'day');
        }
    });
});
// eslint-disable-next-line func-names
yup.addMethod(yup.string, 'hasValidYear', function (...args) {
    return this.test({
        message: args[0],
        test: function hasValidYear(value, context) {
            const dateParts = value?.split('-');
            const year = dateParts?.find(item => item.length === 4) || '';
            const yearDigits = parseInt(year, 10);
            return !(isNaN(yearDigits) ||
                yearDigits < (context.options.context?.minYearOfBirth || 1900) ||
                yearDigits > new Date().getFullYear());
        }
    });
});
// eslint-disable-next-line func-names
yup.addMethod(yup.string, 'isOlderThanInfantOnDateString', function (...args) {
    return this.test({
        message: args[0],
        test: function isOlderThanAgeOnDate(value, context) {
            const childMinAge = context.options.context?.childMinAge;
            const startDate = dayjs(context.options.context?.startDate);
            if (!startDate || childMinAge === null || childMinAge === undefined || !value)
                return false;
            const birthDate = dayjs(value);
            const birthDateAdded = birthDate.add(childMinAge, 'year');
            const daysToAdd = 1;
            return birthDateAdded.isBefore(startDate.add(daysToAdd, 'day'), 'day');
        }
    });
});
// eslint-disable-next-line func-names
yup.addMethod(yup.string, 'isYoungerThanAgeOnDateString', function (...args) {
    return this.test({
        message: args[0],
        test: function isOlderThanAgeOnDate(value, context) {
            const adultMinAge = context.options.context?.adultMinAge;
            const startDate = dayjs(context.options.context?.startDate);
            if (!startDate || !adultMinAge || !value)
                return false;
            const birthDate = dayjs(value);
            const birthDateAdded = birthDate.add(adultMinAge, 'year');
            return birthDateAdded.isAfter(startDate, 'day');
        }
    });
});
// eslint-disable-next-line func-names
yup.addMethod(yup.string, 'isInfantOnDateString', function (...args) {
    return this.test({
        message: args[0],
        test: function isOlderThanAgeOnDate(value, context) {
            const childMinAge = context.options.context?.childMinAge;
            const startDate = dayjs(context.options.context?.startDate);
            if (!startDate || !childMinAge || !value)
                return false;
            const birthDate = dayjs(value);
            const birthDateAdded = birthDate.add(childMinAge, 'year');
            const daysToAdd = 1;
            return birthDateAdded.isAfter(startDate.add(daysToAdd, 'day'), 'day');
        }
    });
});
yup.addMethod(yup.string, 'shouldNotBeNull', function (...args) {
    return this.test({
        message: args[0],
        test: function shouldNotBeNull(value) {
            return value !== null;
        }
    });
});
yup.addMethod(yup.string, 'equalEmails', 
// eslint-disable-next-line func-names
function (...args) {
    return this.test({
        message: args[0],
        test: function equalEmails(value, context) {
            if (!context.options.context?.emailProp)
                return true;
            return value === this.parent[context.options.context?.emailProp];
        }
    });
});
// This method allows custom regular expressions to be validated rather using hardcoded ones:
yup.addMethod(yup.string, 'customRegExValidation', function (...args) {
    return this.test({
        message: args[1],
        test: function customRegExValidation(value) {
            return args[0].test(value);
        }
    });
});
yup.addMethod(yup.string, 'onlyNumbersNotAllowed', function (...args) {
    return this.test({
        message: args[1],
        test: function onlyNumbersNotAllowed(value) {
            const isOnlyNumbers = /^\d+$/.test((value || '').trim());
            return !isOnlyNumbers;
        }
    });
});
yup.addMethod(yup.string, 'specialCharactersNotAllowed', function (...args) {
    return this.test({
        message: args[1],
        test: function specialCharactersNotAllowed(value) {
            const specialCharacterRegex = /^[a-zA-Z0-9\s]*$/;
            return specialCharacterRegex.test(value);
        }
    });
});
yup.addMethod(yup.string, 'onlySpacesNotAllowed', function (...args) {
    return this.test({
        message: args[1],
        test: function onlySpacesNotAllowed(value) {
            return value?.trim().length > 0;
        }
    });
});
const isDateRangeValid = (startDate, endDate, config, dateRangeAllowSameDay) => {
    if (!startDate || !endDate)
        return false;
    const dayjsStart = dayjs(startDate, config.formatDate);
    const dayjsEnd = dayjs(endDate, config.formatDate);
    if (!dayjsStart.isValid() || !dayjsEnd.isValid()) {
        return false;
    }
    if (dayjsStart.isAfter(dayjsEnd)) {
        return false;
    }
    if (!dateRangeAllowSameDay && dayjsStart.isSame(dayjsEnd)) {
        return false;
    }
    const now = dayjs().startOf('day');
    return dayjsStart.isSame(now) || dayjsStart.isAfter(now);
};
// VAlIDATIONS BUILDER
const getBaseElementSchema = (schema, customSchemaMessage) => {
    switch (schema) {
        case 'string':
            return !!customSchemaMessage ? yup.string().typeError(customSchemaMessage) : yup.string();
        case 'boolean':
            return !!customSchemaMessage ? yup.boolean().typeError(customSchemaMessage) : yup.boolean();
        case 'number':
            return !!customSchemaMessage ? yup.number().typeError(customSchemaMessage) : yup.number();
        case 'array':
            return !!customSchemaMessage ? yup.array().typeError(customSchemaMessage) : yup.array();
        case 'object':
            return !!customSchemaMessage ? yup.object().typeError(customSchemaMessage) : yup.object();
        default:
            return !!customSchemaMessage ? yup.string().typeError(customSchemaMessage) : yup.string();
    }
};
/* eslint-disable @typescript-eslint/no-explicit-any */
const createElementSchema = (validations) => {
    let elementSchema = getBaseElementSchema(validations.schema, validations.customSchemaMessage);
    elementSchema = elementSchema.nullable();
    validations.types.forEach(type => {
        if (elementSchema[type.type]) {
            if (type.parameter) {
                elementSchema = elementSchema[type.type](type.parameter, type.customMessage || '');
            }
            else {
                elementSchema = elementSchema[type.type](type.customMessage || '');
            }
        }
    });
    return elementSchema;
};
/* eslint-enable */
const flattenStructure = (rows, keySuffix) => {
    let allElements = {};
    rows.forEach(row => {
        row.elements.forEach(element => {
            if (element.validations) {
                allElements = { ...allElements, [`${element.key}${keySuffix || ''}`]: element.validations };
            }
        });
    });
    return allElements;
};
const createValidationSchema = (rows, keySuffix) => {
    const flattenedElements = flattenStructure(rows, keySuffix);
    return yup.object().shape({
        ...Object.entries(flattenedElements).reduce((schema, [key, item]) => {
            return {
                ...schema,
                [key]: isValidations(item)
                    ? createElementSchema(item)
                    : yup.object().shape({
                        ...Object.entries(item).reduce((innerSchema, [validationKey, validations]) => {
                            return {
                                ...innerSchema,
                                [validationKey]: createElementSchema(validations)
                            };
                        }, {})
                    })
            };
        }, {})
    });
};
const createInitialValues = (rows, keySuffix, initialValues) => {
    const values = rows.reduce((total, currentRow) => {
        return {
            ...total,
            ...currentRow.elements.reduce((totalInner, currentElement) => {
                const key = `${currentElement.key}${keySuffix || ''}`;
                return {
                    ...totalInner,
                    [key]: initialValues && initialValues[key] !== undefined && initialValues[key] !== null
                        ? initialValues[key]
                        : currentElement.initialValue
                };
            }, {})
        };
    }, {});
    if (initialValues) {
        Object.keys(initialValues).forEach(key => {
            if (!(key in values)) {
                values[key] = initialValues[key];
            }
        });
    }
    return values;
};

export { createInitialValues, createValidationSchema, isDateRangeValid };
//# sourceMappingURL=validations.js.map
